import { render } from "./DonationReceivalEventListView.vue?vue&type=template&id=0484c6f8"
import script from "./DonationReceivalEventListView.vue?vue&type=script&lang=js"
export * from "./DonationReceivalEventListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__